import * as types from '../actions/actionTypes';
import initialState from './initialState';
import * as storeConstants from '../store/constants';

const reducer = (state = initialState[storeConstants.JOB_FORM_ACTIVE_SECTION], action) => {
  switch (action.type) {
    case types.JOB_FORM_UPDATE_ACTIVE_SECTION: {
      const { sectionId } = action.payload;
      return {
        ...state,
        sectionId
      };
    }
    default:
      return state;
  }
};

export default reducer;
